import { render, staticRenderFns } from "./BaseTeacherForm.vue?vue&type=template&id=80324f06"
import script from "./BaseTeacherForm.vue?vue&type=script&lang=js"
export * from "./BaseTeacherForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports